import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./router/permission"
import "@/plugins/scss/index.scss";
import ReasyUI from "@/plugins/components/index";

Vue.use(ReasyUI);

//引入表格组件使用
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)
Vue.prototype.$VXETable = VXETable
Vue.config.productionTip = false;

//自定义全局指令，没有权限的不渲染
Vue.directive('permission', {inserted:function (el, binding) {
  const permission = binding.value; // 获取权限值
  const have_permissions = store.state.buttonMenu || ''; // 当前用户拥有的权限
  if (!have_permissions.includes(permission)) {
    // el.parentElement.removeChild(el); //不拥有该权限移除dom元素
  }
}})
//展示json数据 物模型TSL
import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer);
import 'vue-json-viewer/style.css';

import Directives from "@/directives";
Vue.use(Directives);

//过滤器
import Filters from "@/directives/filter";
Vue.use(Filters);

import Global from "@/global";
Vue.use(Global);

import Components from "@/components/index";
Vue.use(Components);

import "@/common/scss/index.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
